"use client";

import { Link } from "@/components/common/Link";
export default function RealEstateHero() {
  return <section data-section-id="264002" id="real-estate-hero" className="bg-background py-12 text-foreground lg:py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid gap-14 lg:grid-cols-[1.05fr_0.95fr] lg:items-start lg:gap-20">
          {}
          <div>
            <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-secondary">
              Real Estate Transactions
            </p>

            <h1 className="max-w-3xl font-serif font-light leading-[1.03] tracking-tight text-primary !text-[48px]">
  Real Estate Transactions Informed by Longstanding Experience
          </h1>

            <p className="mt-6 max-w-2xl font-sans text-lg leading-relaxed text-muted-foreground md:text-xl">
              The Law Office of Morrie I. Levine assists South Florida clients
              with residential and commercial real estate matters, including
              purchases, sales, leases, contract preparation and review, due
              diligence, title issues, and transaction-related concerns.
            </p>

            <p className="mt-4 max-w-2xl font-sans text-lg leading-relaxed text-muted-foreground">
              Each matter is approached through careful review of the governing
              documents, negotiated terms, payment obligations, title and
              closing issues, and the practical consequences of the transaction.
            </p>

            <div className="mt-8">
              <Link to="/ContactUsPage" className="inline-flex items-center justify-center rounded-md bg-primary px-7 py-3.5 font-sans text-sm font-medium text-primary-foreground no-underline transition-opacity hover:opacity-90">
                Discuss Your Real Estate Matter
              </Link>
            </div>
          </div>

          {}
          <div className="border-t border-border pt-8 lg:mt-10">
            <p className="mb-5 font-mono text-xs uppercase tracking-[0.25em] text-secondary">
              Real Estate Experience
            </p>

            <h2 className="font-serif text-3xl font-light leading-tight text-foreground md:text-4xl">
              A Professional Foundation Beginning in Law School
            </h2>

            <div className="mt-7 space-y-6 font-sans text-base leading-relaxed text-muted-foreground md:text-lg">
              <p>
                Morrie I. Levine&apos;s real estate experience began during his
                second year of law school, when he worked as a title closer for
                three title companies in New York, New York.
              </p>

              <p>
                After law school, his first legal position was with one of the
                three law firms handling Citibank N.A.&apos;s residential and
                corporate closings.
              </p>

              <p>
                That early experience with title, closing documentation, and
                transaction structure became part of a practice that has
                continued to include residential and commercial real estate
                matters in South Florida.
              </p>
            </div>
          </div>
        </div>

        {}
        
      </div>
    </section>;
}